import { connect } from 'react-redux';

import {
  createBoardgame,
  getBoardgame,
  updateBoardgame,
  getBoardgameStatistics,
} from '../actions/boardgames';

import { getCategories } from '../actions/categories';

import { boardgameSelector } from '../reducers/boardgames';
import { categoriesSelector } from '../reducers/categories';

import {
  statisticsForBoardgameSelector,
  getLoadingStatisticsSelector,
} from '../reducers/statistics';

import { isLoadingSelector } from '../reducers';

import AdminBoardgamePageComponent from '../components/AdminBoardgamePage';
import { withParams } from '../utilities/reactRouter';

const mapStateToProps = (state, ownProps) => {
  return {
    loading: isLoadingSelector(state),
    boardgame: boardgameSelector(state)(ownProps.params.id),
    categories: categoriesSelector(state),
    loadingStatistics: getLoadingStatisticsSelector(state),
    statistics: statisticsForBoardgameSelector(state)(ownProps.params.id),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    createBoardgame: (bg) => dispatch(createBoardgame(bg)),
    getBoardgame: (id) => dispatch(getBoardgame(id)),
    getCategories: () => dispatch(getCategories()),
    updateBoardgame: (id, bg) => dispatch(updateBoardgame(id, bg)),
    getBoardgameStatistics: (id) => dispatch(getBoardgameStatistics(id)),
  };
};

const AdminBoardgamePage = withParams(
  connect(mapStateToProps, mapDispatchToProps)(AdminBoardgamePageComponent)
);

export default AdminBoardgamePage;
